// extracted by mini-css-extract-plugin
export var scrollArea = "_ql-0";